import React, { FunctionComponent } from 'react';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconDocument: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faFile} />;

export { BrassIconDocument };
